import { createRoot as createRoot } from 'react-dom/client';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initializeLogging2wy35dn799fjs as initializeLogging } from '../../../../../Coupling-libraries-logging/com/zegreatrob/coupling/logging/InitializeLogging.mjs';
import { get_RootComponentir94du7iar4c as get_RootComponent } from './RootComponent.mjs';
import { createywkzgrq4l4xy as create } from '../../../../../kotlin-react/react/create.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { toBooleanStrictOrNull2j0md398tkvbj as toBooleanStrictOrNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { ClientConfig2mpft8d5d0hh3 as ClientConfig } from './ClientConfig.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _get_viewContainerNode__sgyoj($this, _this__u8e3s4) {
  // Inline function 'web.cssom.ClassName' call
  // Inline function 'js.reflect.unsafeCast' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$3 = 'view-container';
  return ensureNotNull(_this__u8e3s4.getElementsByClassName(tmp$ret$3).item(0));
}
function App$bootstrapApp$lambda($this$create) {
  $this$create.clientConfig = windowClientConfig();
  return Unit_instance;
}
var AppClass;
function App() {
  if (AppClass === VOID) {
    class $ {
      v7b() {
        initializeLogging(false);
        var tmp = createRoot(_get_viewContainerNode__sgyoj(this, document));
        var tmp_0 = get_RootComponent();
        tmp.render(create(tmp_0, App$bootstrapApp$lambda));
      }
    }
    initMetadataForObject($, 'App');
    AppClass = $;
  }
  return AppClass;
}
var App_instance;
function App_getInstance() {
  return App_instance;
}
function windowClientConfig() {
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = window;
  var tmp = toBooleanStrictOrNull('' + tmp$ret$0['prereleaseMode']) === true;
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = '' + window['auth0ClientId'];
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_1 = '' + window['auth0Domain'];
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_2 = '' + window['basename'];
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_3 = '' + window['expressEnv'];
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_4 = '' + window['webpackPublicPath'];
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$6 = window;
  return new (ClientConfig())(tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, '' + tmp$ret$6['websocketHost']);
}
//region block: init
App_instance = new (App())();
//endregion
//region block: exports
export {
  App_instance as App_instance2s454d4i1xcik,
};
//endregion

//# sourceMappingURL=App.mjs.map
